import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import moment from 'moment-timezone';

const SkeletonPayload = {
  subject: {
    id: 'skeleton',
    subject_step_ids: ['skeleton-1', 'skeleton-2', 'skeleton-3', 'skeleton-4', 'skeleton-5'],
  },
  subject_steps: [
    { id: 'skeleton-1', type: 'match_campaign' },
    { id: 'skeleton-2', type: 'skeleton' },
    { id: 'skeleton-3', type: 'skeleton', due: moment().unix() },
    { id: 'skeleton-4', type: 'skeleton', future: true },
    { id: 'skeleton-5', type: 'exit_campaign', future: true },
  ],
};

export default class SubjectLoadingRoute extends Route {
  @service store;

  templateName = 'person/subjects/subject';

  setupController(controller) {
    super.setupController(...arguments);
    this.store.pushPayload(SkeletonPayload);
    controller.set('model', this.store.peekRecord('subject', 'skeleton'));
  }

  deactivate() {
    super.deactivate(...arguments);

    let model = this.controller.get('model');

    model
      .get('subjectSteps')
      .toArray()
      .map((s) => this.store.unloadRecord(s));
    this.store.unloadRecord(model);
  }
}
